<script>
  import { setContext } from 'svelte';

  /** Usage Example

  <DraggableList bind:list={my_list} direction='row'>
		{#each my_list as item, index}
      <DraggableItem {item} {index}>
        <ButtonLabel look='clear' start_icon="drag-handle" />
        <span>{item.name}</span>
      </DraggableItem>
		{/each}
	</DraggableList>

  */


  let {
    children,
    /** @type {Array<any>} */
    list = $bindable(),
    /** @type {'row' | 'column'} */
    direction = 'column',
    /** @type {number?} index of item currently being dragged */
    dragging_item = null,
    ...rest
  } = $props();

  const draggable_context_key = 'draggable_context';

  function set_dragging_item(index) {
    dragging_item = index;
  }

	/**
	 * @param {number} start_index - The start index of the item being dragged
	 * @param {number} end_index - The index where the item is dropped
	 */
  function update_list_order(start_index, end_index) {
    const item = list.splice(start_index, 1)[0];
    list.splice(end_index, 0, item);
  }


  setContext(draggable_context_key, {
    set_dragging_item,
    update_list_order,
    get direction() { return direction; }
  });
</script>

{#if children}
  <div 
    role="list"
    class="draggable-list {direction === 'row' ? 'flex-row' : direction === 'column' ? 'flex-column' : ''} {rest.class ? rest.class : ''}"
    {...rest}
  >
    {@render children()}
  </div>
{/if}